import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import ChatView from 'components/composed/views/ChatView';

const StyledContainer = styled.div`
  @media ${theme.devices.tablet} {
  }
`;

const ChatSection = () => {
  return (
    <StyledContainer>
      <ChatView />
    </StyledContainer>
  );
};

export default ChatSection;
